import React, { useEffect } from 'react';
import { Modal, Button } from 'antd';
import './SelfPayUpgradeModal.css';
import { PATH_CUSTOMER_ID } from '../../../MortgageGPT/constants';
import { useTrackEvent } from '../../../MortgageGPT/analytics/useTrackEvent';

interface SelfPayUpgradeModalProps {
  isOpen: boolean;
  onCancel: () => void;
  triggerType?: 'default' | 'promo-code-applied' | 'usage-limit-reached' | 'past-due' | 'signin' | 'signup' | 'usage-limit-reached-alert' | 'header-cta' | 'billing-cta';
  onCheckOut: () => void;
  selfPayPriceAmount: number;
  portalSessionUrl: string;
  currentBillingStatus: string;
  promoCodeValidity: string;
  profile?: any;
  usage?: number;
}

const SelfPayUpgradeModal: React.FC<SelfPayUpgradeModalProps> = ({
  isOpen,
  onCancel,
  triggerType = 'default',
  onCheckOut,
  selfPayPriceAmount,
  portalSessionUrl,
  currentBillingStatus,
  promoCodeValidity,
  profile,
  usage,
}) => {
  const { trackPaywallDisplayed, trackUpgradeInitiated, trackCheckoutStarted } = useTrackEvent();

  // Track paywall displayed when modal opens
  useEffect(() => {
    if (isOpen && triggerType !== 'past-due') {
      trackPaywallDisplayed(triggerType, profile, usage, currentBillingStatus);
    }
  }, [isOpen, triggerType, profile, usage, trackPaywallDisplayed]);

  const handleUpgradeClick = () => {
    trackUpgradeInitiated(triggerType, profile, usage, currentBillingStatus);
    trackCheckoutStarted(triggerType, profile, usage, currentBillingStatus);
    onCheckOut();
  };

    const displayImage = () => {
        return (
            <div className='self-pay-modal-img-box'>
                <div className='self-pay-modal-logo-box'>
                    <img src='/images/login-logo.png' />
                </div>
               
                <div className='self-pay-modal-img-box-content'>
                   Work smarter with unlimited access
                </div>

                <span/>
            </div>
        )
    }

    const renderRightPanelHeaderSub = () => {
        switch (triggerType) {
            case 'usage-limit-reached':
                return <div className='right-panel-header-subtext'>You've hit your free limit. Upgrade for unlimited usage.</div>
            case 'usage-limit-reached':
                return <div className='right-panel-header-subtext'>You've hit your free limit. Upgrade for unlimited usage.</div>
            default:
                return <div className='right-panel-header-subtext'>Unlock unlimited usage by upgrading to Business plan.</div>
        }
    }

    const renderPlanPriceInfo = () => {
        switch (triggerType) {
            case 'promo-code-applied':
                return <div className='plan-info-price'>
                        <span className='plan-info-price-free-highlight'>
                            1 month free
                        </span>
                        , then ${selfPayPriceAmount}/month
                </div>
            case 'usage-limit-reached':
                if (PATH_CUSTOMER_ID === 'successlending' && currentBillingStatus === 'inactive' && promoCodeValidity === 'valid') {
                    return <div className='plan-info-price'>
                        <span className='plan-info-price-free-highlight'>
                            1 month free
                        </span>
                        , then ${selfPayPriceAmount}/month
                    </div>
                } else {
                    return <div className='plan-info-price'><span className='plan-info-price-highlight'>${selfPayPriceAmount}</span>/month</div>
                }
            case 'usage-limit-reached-alert':
                if (PATH_CUSTOMER_ID === 'successlending' && currentBillingStatus === 'inactive' && promoCodeValidity === 'valid') {
                    return <div className='plan-info-price'>
                        <span className='plan-info-price-free-highlight'>
                            1 month free
                        </span>
                        , then ${selfPayPriceAmount}/month
                    </div>
                } else {
                    return <div className='plan-info-price'><span className='plan-info-price-highlight'>${selfPayPriceAmount}</span>/month</div>
                }
            default:
                return <div className='plan-info-price'><span className='plan-info-price-highlight'>${selfPayPriceAmount}</span>/month</div>
        }
    }

    const onManageBilling = () => {
        window.location.href = portalSessionUrl;
    }

    return (
        <>
        {triggerType === 'past-due' ? (
            <Modal
                open={isOpen}
                onCancel={onCancel}
                footer={null}
                width={490}
                height={240}
                centered
                className="past-due-modal"
                maskClosable={false}
            >
                <div className='past-due-modal-container'>
                    <div className='past-due-modal-title'><img src='/images/red-alert.svg' /> Subscription ended</div>
                    <div className='past-due-modal-text'>Your Business plan was canceled because your payment failed. Please update your payment method to restore it.</div>
                    <div className='past-due-modal-action-box'>
                        <Button type="primary" className='manage-billing-btn' onClick={onManageBilling}>Update payment method</Button>
                    </div>
                </div>
            </Modal>
        ):(
            <Modal
                open={isOpen}
                onCancel={onCancel}
                footer={null}
                width={960}
                height={624}
                centered
                className="self-pay-modal"
                maskClosable={false}
                closable={false}
            >
                <div className="self-pay-modal-container">
                    <div className="self-pay-modal-left-panel">
                        <div className="self-pay-modal-left-panel-content">
                        {/* {displayImage()} */}
                        </div>
                    </div>
                    <div className="self-pay-modal-right-panel">
                        <div>
                            <div className='right-panel-header'>
                                <div className='right-panel-header-title'>Upgrade to Business</div>
                                {renderRightPanelHeaderSub()}
                            </div>
                            <div className='plan-info'>
                                <div className='plan-info-title'>Business Plan</div>
                                {renderPlanPriceInfo()}
                                {/* <div className='plan-info-price'><span className='plan-info-price-highlight'>${selfPayPriceAmount}</span> /month</div> */}
                                <div className='plan-info-price-note'>No commitments. Cancel anytime.</div>
                            </div>

                            <hr />

                            <div className='plan-access'>
                                <div className='plan-access-item'>
                                    <img src='/images/checkmark.svg' />
                                    <div>Unlimited queries</div>
                                </div>
                                <div className='plan-access-item'>
                                    <img src='/images/checkmark.svg' />
                                    <div>Customized lender guidelines</div>
                                </div>
                            </div>

                            <div className='plan-actions'>
                                <Button className='upgrade-btn' type="primary" onClick={handleUpgradeClick}>Upgrade</Button>
                                <span className='decline-btn' onClick={onCancel}>Maybe later</span>
                            </div>
                        </div>

                        <div className='right-panel-footer'>
                            <div className='right-panel-disclaimer'>By confirming your subscription, you allow Zeitro, Inc. to charge you for future payments in accordance with their terms.</div>
                            <div className='right-panel-powered-by'>Powered by <img src='/images/stripe-text-icon.svg' className='powered-by-highlight' /> | <span onClick={() => window.open('https://stripe.com/privacy', '_blank')}>Privacy </span>| <span onClick={() => window.open('https://stripe.com/legal/consumer', '_blank')}>Terms</span></div>
                        </div>
                    </div> 
                </div>
            </Modal>
        )}
        </>
    );
};

export default SelfPayUpgradeModal;